import { DataType } from '@/core/data/DataType';
import { VueConstructor } from 'vue';
import { ReportBlocks } from './ReportBlocks';
import { ReportBlockWrapper } from './ReportBlockWrapper';

export function ReportBlock<T extends VueConstructor>(tabName: string, iconHtml: string, requiredTypes: DataType[], displayed: () => boolean = () => true) {
    return (ctr: T) => {
        ReportBlocks.RegisterTab(new ReportBlockWrapper(ctr, tabName, iconHtml, requiredTypes, displayed));
    }
}
